import { CustomProperty, CustomPropertyType, EmployeeRecord, CustomPropertyValue } from "winslow-core";
import { validateEmail } from "../../uiHelpers";

// expects customProperties to be a JSON string
// with the following format:
// [{label: string, value: string}, ...]

export const erGetCPValue = (er: Partial<EmployeeRecord> | null, property: string) : any => {
    if (!er) {
        return null;
    }

    if (!er.customProperties) {
        return null;
    }

    const properties = JSON.parse(er.customProperties) as CustomPropertyValue[];

    if (!properties) {
        return null;
    }

    const propertyObj = properties.find((p) => p.label === property);
    if (!propertyObj) {
        return null;
    }

    return(propertyObj.data); 
}

// returns the new stringified customProperties or original customProperties
// if the property was not found, add it to the end
export const erSetCPValue = (er: Partial<EmployeeRecord>, property: string, data: any) => {
    if (!er.customProperties) {
        return er.customProperties;
    }

    const properties = JSON.parse(er.customProperties) as CustomPropertyValue[];

    if (!properties) {
        return er.customProperties;
    }

    const index = properties.findIndex((p: CustomPropertyValue) =>  p.label === property);

    if (index === -1) {
        properties.push({ label: property, data: data } as CustomPropertyValue);
    } else {
        properties[index].data = data;
    }

    return(JSON.stringify(properties));
}

export const cpGetDropdownChoices = (cps: CustomProperty[] | undefined, property: string) => {

    if (!cps) {
        return null;
    }
    
    const cp = cps.find((cp) => cp.label === property);
   
    if (!cp) {
        return null;
    }

    if (cp.type !== CustomPropertyType.DROPDOWN) {
        return null;
    }

    const settings = JSON.parse(cp.settings);

    if (!settings) {
        return null;
    }

    return settings.choices;
}

export const erIsValid = (er: Partial<EmployeeRecord> | null, cps: CustomProperty[]) : boolean => {
    if (!er) {
        console.error("erIsValid: er is null");
        return false;
    }

    if (!er.workEmail || !validateEmail(er.workEmail)) {
        console.error("erIsValid: workEmail is invalid");
        return false;
    }

    if (!er.employeeType) {
        console.error("erIsValid: employeeType is invalid");
        return false;
    }

    const cpValues = er.customProperties ? JSON.parse(er.customProperties || "[]") as CustomPropertyValue[] : [] as CustomPropertyValue[];

    for (let i = 0; i < cps.length; i++) {
        const cpv = cpValues.find((cpv) => cpv.label === cps[i].label);
       
        if (cps[i].required && !cpv?.data) {
            console.error(`erIsValid: ${cps[i].label} is required (currently ${cpv?.data})`);
            return false;
        }

        switch(cps[i].type) {
            case CustomPropertyType.CHECKBOX_MULTIPLE:
                if (cpv?.data && cpv.data.length === 0) {
                    console.error(`erIsValid: ${cps[i].label} is required`);
                    return false;
                }
                break;
            case CustomPropertyType.RADIO:
                if (cpv?.data && cpv.data.length === 0) {
                    console.error(`erIsValid: ${cps[i].label} is required`);
                    return false;
                }
                break;
            // case CustomPropertyType.DROPDOWN:
            //     if (cpv?.data && cpv.data.length === 0) {
            //         console.error(`erIsValid: ${cps[i].label} is required`);
            //         return false;
            //     }
            //     break;
        }

        const settings = JSON.parse(cps[i].settings || "{}");

        switch(cps[i].type) {
            case CustomPropertyType.EMAIL:
                if (cpv?.data && !validateEmail(cpv?.data)) {
                    console.error(`erIsValid: ${cps[i].label} is invalid email`);
                    return false;
                }
                break;
            case CustomPropertyType.NUMBER:
                if (cpv?.data && isNaN(cpv?.data)) {
                    console.error(`erIsValid: ${cps[i].label} is invalid number`);
                    return false;
                }

                if (settings.minNumOn && cpv?.data && cpv?.data < settings.minNum) {
                    console.error(`erIsValid: ${cps[i].label} is less than the minimum number`);
                    return false;
                }   

                if (settings.maxNumOn && cpv?.data && cpv?.data > settings.maxNum) {
                    console.error(`erIsValid: ${cps[i].label} is greater than the maximum number`);
                    return false;
                }

                break;
            // case CustomPropertyType.CHECKBOX_MULTIPLE:
            //     if (cpv?.data && atLeastOneValue(cpv?.data)) {
            //         console.error(`erIsValid: ${cps[i].label} `);
            //         return false;
            //     }
            //     break;
            default:
                break;
        }
    }

    return true;
}